import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { IdentityVerificationScreen } from "../../screens/identity-verification";
export const IdentityVerificationChallenge = t0 => {
  const $ = _c(12);
  const {
    api,
    onReady,
    onSuccess,
    onClose,
    onError
  } = t0;
  let t1;
  let t2;
  if ($[0] !== onReady) {
    t1 = () => {
      onReady();
    };
    t2 = [onReady];
    $[0] = onReady;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onSuccess) {
    t3 = () => onSuccess();
    $[3] = onSuccess;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onError) {
    t4 = () => onError({
      code: "generic",
      message: "Identity verification could not be completed"
    });
    $[5] = onError;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== api || $[8] !== onClose || $[9] !== t3 || $[10] !== t4) {
    t5 = <IdentityVerificationScreen api={api} onComplete={t3} onCancel={onClose} onError={t4} />;
    $[7] = api;
    $[8] = onClose;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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